module.exports = __webpack_public_path__ + "img/EN-img.dc806751.png";